import rows from '@/mixins/rows.js';
export default {
    mixins:[rows],
    props: { 
        headers: Array,
        fields: Array,
        schemaName: { type:String, required: true},
        defaultSort: String,
    },
    data(){
        return {
            currentSort:"",
            isNotPages: false,
            currentSortType: "asc",
            currentPage: 1,
            sizePage: 15,
            loading: true,
            filter: {
                type: "",
                value: null,
                field: ""
            },
            filterTypes: [
                { name: "Дорівнює", value: "Equal", char:"=", type: "all"},
                { name: "Не дорівнює", value: "NotEqual", char: "<>", type: "all" },                
                { name: "Більше", value: "More", char: ">", type: "number, date" },
                { name: "Меньше", value: "Less", char:"<", type: "number, date" },
                { name: "Включає", value: "Contains", char:"включає", type: "string" },
                { name: "Виключає", value: "NotContains", char:"виключає", type: "string" }
            ],
            pagination: {
                entities:[]
            },
            filters:[],
        }
    },
    computed: {
        currentPageSize:{
            get(){
                return this.sizePage * this.currentPage;   
            }
        },
        oldPageSize:{
            get(){
                return this.sizePage * (this.currentPage - 1);
            }
        },
        currentSortDir: {
            get() {
                return this.currentSortType;
            },
            set(value) {
                this.currentSortType = value;
            }
        },
        rowsData: {
            get() {
                return this.rowsSortData
            }
        },        
        rowsSortData: {
            get() {
                return [...this.rowsFilterData].sort((a,b) => {
                    let modifier = 1;
                    if(this.currentSortDir === 'desc') modifier = -1;
                    if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                    if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    return 0;
                });
            }
        },
        rowsFilterData: {
            get() {
                var data = [...this.pagination.entities];              
                return data;
            }
        }
    },
    watch: {
        filters: {
            handler() {
                this.loadRows();
            },
            deep:true
        }
    },
    methods: {
        nextPage(){
            if (this.pagination.totalPages > this.currentPage)
            {
                this.currentPage += 1;
                this.loadRows();
            }
        },
        backPage(){
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.loadRows();
            }
        },
        getFilterString(filter) {
            return this.localizeColumn(this.fields.find(x => x.field == filter.field))
        },
        getColumnLocaleKeys(column) {
            const field = column?.field?.replace(/[^A-Za-z0-9]/g, "_");
            return [
                column?.localeKey,
                field ? `tableColumns.${this.schemaName}.${field}` : null,
                field ? `tableColumns.common.${field}` : null,
            ].filter(Boolean);
        },
        localizeColumn(column) {
            const fallback = column?.name ?? "";
            const key = this.getColumnLocaleKeys(column)
                .find((item) => {
                    const value = this.$filters.localize(item);
                    return value && !String(value).startsWith("[Localize error]");
                });
            return key ? this.$filters.localize(key) : fallback;
        },
        formatDate(date) {
            var dateField = new Date(date);
            return new Date(dateField.getFullYear(), dateField.getMonth(), dateField.getDate());
        },
        addFilter(filter) {
            this.filters.push(filter);
            localStorage.setItem(this.schemaName, JSON.stringify(this.filters));
            this.filter = {
                type: "",
                value: null,
                field: ""
          };
            this.currentPage = 1;
            this.loadRows();
        },
        removeFilter(indexFilter) {
            this.filters = this.filters.filter((_, index) => index !== indexFilter);
            localStorage.setItem(this.schemaName, JSON.stringify(this.filters));
            this.loadRows();
        },
        clearFilters() {
            this.filters = [];
            localStorage.removeItem(this.schemaName);
        },
        sort(field) {
            if(field === this.currentSort) 
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            this.currentSort = field;
        },
        loadRows() {
            this.loading = true;
            this.$store.dispatch('pagination', { table: this.schemaName, query: { page: this.currentPage, filters: this.filters }})
                .then((response) => {
                    this.pagination = response.data.data;
                    this.loading = false;
            });
        },
    },
    mounted() {
        this.currentSort = this.headers[0].field;
        if(this.defaultSort)
            this.currentSortDir = this.defaultSort;
        var result = localStorage.getItem(this.schemaName);
        if(result)
            this.filters = JSON.parse(result);
    }
}
